// RF-147 — tags removibles individuales por filtro activo (antes: solo el botón de limpiar,
// en FilterBar, sin forma de quitar un filtro a la vez). Vive en Reportería, no en FilterBar: ese
// componente es compartido con el módulo Analytics genérico y no se toca.
import { useTranslation } from 'react-i18next';

export interface FilterTag {
  key: string;
  label: string;
  /**
   * Cómo se quita este filtro. OPCIONAL: un tag sin `onRemove` se pinta sin la «×».
   *
   * 🔴 Existe para el rango de fechas, que SIEMPRE está puesto (por omisión, la semana en curso) y por
   * tanto siempre se enseña — pero cuando ya está en su valor por omisión no hay nada que quitar. Una
   * «×» que no hace nada invita a pulsarla y a dudar de la pantalla cuando no pasa nada.
   */
  onRemove?: () => void;
}

export function FilterTags({ tags }: Readonly<{ tags: FilterTag[] }>) {
  const { t } = useTranslation('recognition');
  if (tags.length === 0) return null;

  return (
    <div className="rr-filter-tags" role="list">
      {tags.map((tag) => (
        <span key={tag.key} className="rr-filter-tag" role="listitem">
          {tag.label}
          {tag.onRemove && (
            <button
              type="button"
              className="rr-filter-tag-remove"
              onClick={tag.onRemove}
              aria-label={t('reports.filters.remove', { filter: tag.label })}
            >
              <i className="fas fa-xmark" aria-hidden="true" />
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
